__turbopack_context__.v({
  "Root": "Xe4rBW_Root",
  "skeleton-loading": "Xe4rBW_skeleton-loading",
});
